/**
 * `Cards | Table` — the phone-only switch between the card list and the sticky-name grid
 * (P-042 §3, M0-F9 §5.2 / F9-D30). Rendered nowhere but a phone, so it cannot move a captured
 * desktop pixel; the choice it writes is remembered per user by `usePhoneBoardLayout`.
 */
import type { PhoneBoardLayout } from './usePhoneLayout';

const OPTIONS: { id: PhoneBoardLayout; label: string }[] = [
  { id: 'cards', label: 'Cards' },
  { id: 'table', label: 'Table' },
];

export function LayoutToggle({
  layout,
  onChange,
}: {
  layout: PhoneBoardLayout;
  onChange(next: PhoneBoardLayout): void;
}) {
  return (
    <div className="ez-phone-layout" role="group" aria-label="Board layout" data-testid="phone-layout-toggle">
      {OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          className="ez-phone-layout__option"
          aria-pressed={layout === option.id}
          data-selected={layout === option.id || undefined}
          data-testid={`phone-layout-${option.id}`}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
